import React from 'react';
import { Navigate } from 'react-router';
import ApplicationPage from './components/ApplicationPage';
import FindApplication from './components/FindApplication';
import { MenuAfterShowNew } from '../../utils/formatters';
import Empty from '../../components/base/Empty';
import PresetLink from './components/PresetLink';
import { HIDE_SYSTEM_ROUTE } from '../../configs';
import AwaitDocumentPage from './components/AwaitDocumentPage';
import ApplicationHistoryPage from './components/ApplicationHistoryPage';
import MaisEduHistoryDialog from './components/MaisEduHistoryDialog';

const routes = [
  {
    path: '/',
    component: () => <Navigate to="/application" />,
    weight: 2,
    hideOnMenu: HIDE_SYSTEM_ROUTE,
    permission: [],
    children: [],
    loginRequired: true,
    forAll: true,
  },
  {
    path: '/application',
    name: 'menu.application',
    icon: 'application',
    customIcon: true,
    loginRequired: true,
    forAll: true,
    component: ApplicationPage,
    weight: 2,
    permission: [],
    children: [
      {
        path: '',
        name: 'menu.application',
        icon: 'application',
        customIcon: true,
        loginRequired: true,
        onlyComponent: true,
        forAll: true,
        component: Empty,
        MenuComponent: FindApplication,
        weight: 2,
        permission: [],
        children: [],
      },
      {
        path: 'application?procedure=%5B%221227.1%22%2C%221227.2%22%2C%221227.3%22%2C%221227.4%22%2C%221227.5%22%5D',
        name: 'menu.application.carrier-list',
        icon: 'application',
        customIcon: true,
        loginRequired: true,
        onlyComponent: true,
        forAll: true,
        component: () => {},
        MenuComponent: PresetLink,
        afterContent: <MenuAfterShowNew />,
        weight: 2,
        permission: [],
        children: [
          {
            path: 'application?procedure=%5B%221227.1%22%5D',
            name: 'menu.application.1227.1',
            icon: 'application',
            customIcon: true,
            loginRequired: true,
            onlyComponent: true,
            forAll: true,
            component: () => {},
            MenuComponent: PresetLink,
            weight: 2,
            permission: [],
            children: [],
          },
          {
            path: 'application?procedure=%5B%221227.2%22%5D',
            name: 'menu.application.1227.2',
            icon: 'application',
            customIcon: true,
            loginRequired: true,
            onlyComponent: true,
            forAll: true,
            component: () => {},
            MenuComponent: PresetLink,
            weight: 2,
            permission: [],
            children: [],
          },
          {
            path: 'application?procedure=%5B%221227.3%22%5D',
            name: 'menu.application.1227.3',
            icon: 'application',
            customIcon: true,
            loginRequired: true,
            onlyComponent: true,
            forAll: true,
            component: () => {},
            MenuComponent: PresetLink,
            weight: 2,
            permission: [],
            children: [],
          },
          {
            path: 'application?procedure=%5B%221227.4%22%5D',
            name: 'menu.application.1227.4',
            icon: 'application',
            customIcon: true,
            loginRequired: true,
            onlyComponent: true,
            forAll: true,
            component: () => {},
            MenuComponent: PresetLink,
            weight: 2,
            permission: [],
            children: [],
          },
          {
            path: 'application?procedure=%5B%221227.5%22%5D',
            name: 'menu.application.1227.5',
            icon: 'application',
            customIcon: true,
            loginRequired: true,
            onlyComponent: true,
            forAll: true,
            component: () => {},
            MenuComponent: PresetLink,
            weight: 2,
            permission: [],
            children: [],
          },
        ],
      },
      {
        path: '/application?procedure=%5B%221227.6%22%2C%221227.7%22%2C%221227.8%22%2C%221227.9%22%2C%22kt-exlt%22%5D',
        name: 'menu.application.passenger.taxi.list',
        icon: 'application',
        customIcon: true,
        loginRequired: true,
        onlyComponent: true,
        forAll: true,
        component: () => {},
        MenuComponent: PresetLink,
        afterContent: <MenuAfterShowNew />,
        weight: 2,
        permission: [],
        children: [
          {
            path: 'application?procedure=%5B%221227.6%22%5D',
            name: 'menu.application.1227.6',
            icon: 'application',
            customIcon: true,
            loginRequired: true,
            onlyComponent: true,
            forAll: true,
            component: () => {},
            MenuComponent: PresetLink,
            weight: 2,
            permission: [],
            children: [],
          },
          {
            path: 'application?procedure=%5B%221227.7%22%5D',
            name: 'menu.application.1227.7',
            icon: 'application',
            customIcon: true,
            loginRequired: true,
            onlyComponent: true,
            forAll: true,
            component: () => {},
            MenuComponent: PresetLink,
            weight: 2,
            permission: [],
            children: [],
          },
          {
            path: 'application?procedure=%5B%221227.8%22%5D',
            name: 'menu.application.1227.8',
            icon: 'application',
            customIcon: true,
            loginRequired: true,
            onlyComponent: true,
            forAll: true,
            component: () => {},
            MenuComponent: PresetLink,
            weight: 2,
            permission: [],
            children: [],
          },
          {
            path: 'application?procedure=%5B%221227.9%22%5D',
            name: 'menu.application.1227.9',
            icon: 'application',
            customIcon: true,
            loginRequired: true,
            onlyComponent: true,
            forAll: true,
            component: () => {},
            MenuComponent: PresetLink,
            weight: 2,
            permission: [],
            children: [],
          },
          {
            path: 'application?procedure=%5B%22kt-exlt%22%5D',
            name: 'menu.application.kt-exlt',
            icon: 'application',
            customIcon: true,
            loginRequired: true,
            onlyComponent: true,
            forAll: true,
            component: () => {},
            MenuComponent: PresetLink,
            weight: 2,
            permission: [],
            children: [],
          },
        ],
      },
      {
        path: '/application?procedure=%5B%221228.1%22%2C%221228.2%22%2C%221228.3%22%2C%221228.4%22%5D',
        name: 'menu.application.szlt.list',
        icon: 'application',
        customIcon: true,
        loginRequired: true,
        onlyComponent: true,
        forAll: true,
        component: () => {},
        MenuComponent: PresetLink,
        afterContent: <MenuAfterShowNew />,
        weight: 2,
        permission: [],
        children: [
          {
            path: 'application?procedure=%5B%221228.1%22%5D',
            name: 'menu.application.1228.1',
            icon: 'application',
            customIcon: true,
            loginRequired: true,
            onlyComponent: true,
            forAll: true,
            component: () => {},
            MenuComponent: PresetLink,
            weight: 2,
            permission: [],
            children: [],
          },
          {
            path: 'application?procedure=%5B%221228.2%22%5D',
            name: 'menu.application.1228.2',
            icon: 'application',
            customIcon: true,
            loginRequired: true,
            onlyComponent: true,
            forAll: true,
            component: () => {},
            MenuComponent: PresetLink,
            weight: 2,
            permission: [],
            children: [],
          },
          {
            path: 'application?procedure=%5B%221228.3%22%5D',
            name: 'menu.application.1228.3',
            icon: 'application',
            customIcon: true,
            loginRequired: true,
            onlyComponent: true,
            forAll: true,
            component: () => {},
            MenuComponent: PresetLink,
            weight: 2,
            permission: [],
            children: [],
          },
          {
            path: 'application?procedure=%5B%221228.4%22%5D',
            name: 'menu.application.1228.4',
            icon: 'application',
            customIcon: true,
            loginRequired: true,
            onlyComponent: true,
            forAll: true,
            component: () => {},
            MenuComponent: PresetLink,
            weight: 2,
            permission: [],
            children: [],
          },
        ],
      },
      {
        path: '/application?draft=1',
        name: 'menu.application.draft.list',
        icon: 'application',
        customIcon: true,
        loginRequired: true,
        onlyComponent: true,
        forAll: true,
        component: () => {},
        MenuComponent: PresetLink,
        weight: 2,
        permission: [],
      },
      {
        path: '/application/await-document',
        name: 'menu.application.documents',
        icon: 'application',
        customIcon: true,
        loginRequired: true,
        forAll: true,
        component: AwaitDocumentPage,
        weight: 2,
        permission: [],
        children: [],
      },
      {
        path: '/application/history',
        name: 'menu.application.history',
        icon: 'application',
        customIcon: true,
        loginRequired: true,
        forAll: true,
        component: ApplicationHistoryPage,
        weight: 2,
        permission: [],
        children: [],
      },
      {
        path: '/application/mais-history',
        name: 'menu.mais.registry',
        icon: 'mais',
        customIcon: true,
        loginRequired: true,
        forAll: true,
        component: MaisEduHistoryDialog,
        weight: 2,
        permission: [],
        children: [],
        hideOnMenu: true,
      },
    ],
  },
];

export default routes;
